import type { BillingStatus } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { CancellationInputZodSchemaType } from "./validation-schema";

const _excludeKeys = [
	"hotelID",
	"defaultBasicBillingTicketID",
	"defaultProBillingTicketID",
	"isStopRecurringBasicBilling",
	"isStopRecurringProBilling",
] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

type QueryData = BillingStatus;

export type CancellationFormModel = AutoGeneratorForFormModel<CancellationInputZodSchemaType, ExcludeKeys, QueryData>;
